import { action, computed, makeObservable, observable } from 'mobx';
import { MEASURE_NUTRIENT } from 'src/constants/main';
import { IProductNutrient } from '~/types/product';
import { defaultNutrients } from '~/view/containers/Modals/NutrientsModal/constants/nutrients';

export class NutrientsStore {
  constructor() {
    makeObservable(this);
  }

  @observable tempNutrientValues: IProductNutrient = defaultNutrients;
  @observable isValid = true;

  @action setTempNutrients(value: IProductNutrient | null) {
    if (value) {
      this.tempNutrientValues = value;
    } else {
      this.tempNutrientValues = defaultNutrients;
    }
  }

  @action setTempNutrientValue(field: string, value: number | string | null | MEASURE_NUTRIENT) {
    this.tempNutrientValues = {
      ...this.tempNutrientValues,
      [field]: value,
    };

    if (field === 'serving_unit' && value === MEASURE_NUTRIENT.PORTION) {
      this.tempNutrientValues = {
        ...this.tempNutrientValues,
        serving_size: 1,
      };
      this.isValid = true;
    }

    if (field === 'serving_size') this.validateServingSize(Number(value));
  }

  @action validateServingSize = (serving_size: number) => {
    this.isValid = serving_size >= 1;
  };

  @computed get nutrientsList() {
    const map = new Map<string, number | string | null | MEASURE_NUTRIENT>(Object.entries(this.tempNutrientValues));
    let nutrients = defaultNutrients;

    map.forEach((value, key) => {
      const nutrientType = key as keyof IProductNutrient;
      let computedValue = value;

      if (key !== 'serving_unit') {
        computedValue = parseFloat(String(value ?? 0));
      } else {
        computedValue = value ?? MEASURE_NUTRIENT.GR;
      }

      nutrients = {
        ...nutrients,
        [nutrientType]: computedValue,
      };
    });

    return nutrients;
  }

  @action clearTemp() {
    this.tempNutrientValues = defaultNutrients;
    this.isValid = true;
  }
}

export const nutrientsStore = new NutrientsStore();
